import { DisabledPrompt, Link , useWorkflowStep,useBCMSContext,BCMSRecord,useRoute} from "@bcm-dev/bcms-vite";
import CardFreeCashWrapper from "components/shared/containers/CardFreeCashWrapper";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UIPrimaryButton } from "components/ui/UIButton";
import React from "react";
import {getDefault,  getWorkflowSteps} from "components/workflows/CardFreeCashWorkflow";
import { Card } from "model";
import CardUserInformationWidget from "./components/CardUserInformationWidget";
import "./styles.css";

/**
 * @function SelectCashAmountPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SelectCashAmountPage
 */

export default function SelectCashAmountPage(props) {
  const globalController = useBCMSContext();
  const navigate = useRoute();
  BCMSRecord.globalControllerFor([ Card ], globalController);
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);

const amount = workflowStep.getStepState.cashAmount


const updateAmount = amount=>{
  workflowStep.update([ "cashAmount" ],amount);
};
const submit = evt => {
  workflowStep.update([ "cashAmount" ],amount??getDefault.cashAmount);  
  workflowStep.workflow.nextStep(workflowStep.getStepState);
};
  return(
    <CardFreeCashWrapper className="select-cash-amount-page">
      <MainContentContainer header={<MainContentHeader text="Select Cash Amount" />}>
        

        <CardUserInformationWidget />

        <div className="main-lower-content text-center">
          <p className="text-center">How much would you like to withdraw?</p>

          {/* Tiles */}
          <div className="amount-tile-container flex-container flex-horizontal flex-wrap align-center-container column-space-between-container">
            {/* Pass a className of .selected-tile to make an active tile. */}
            <AmountTile text="$20" onClick={updateAmount} className={amount==="$20"?"selected-tile":"" }/>
            <AmountTile text="$40" onClick={updateAmount}  className={amount==="$40"?"selected-tile":"" }/>
            <AmountTile text="$60"  onClick={updateAmount}  className={amount==="$60"?"selected-tile":"" }/>
            <AmountTile text="$80"  onClick={updateAmount}  className={amount==="$80"?"selected-tile":"" }/>
            <AmountTile text="$100"  onClick={updateAmount}  className={amount==="$100"?"selected-tile":"" }/>
            <DisabledPrompt>
              <AmountTile text="other" />
            </DisabledPrompt>
          </div>
          

          <div className="links-container flex-container flex-horizontal align-center-container column-space-between-container">
            <DisabledPrompt>
              <Link>
                <p>Find an ATM</p>
              </Link>
            </DisabledPrompt>
            <DisabledPrompt>
              <Link>
                <p>How it works</p>
              </Link>
            </DisabledPrompt>
          </div>

          <UIPrimaryButton text="Get Code"  onClick={ submit }  />
        </div>
      </MainContentContainer>
    </CardFreeCashWrapper>
  );
}

/**
 * @function AmountTile
 * @param {String} text - Allows us to set the text that shows in the tile
 * @param {String} className - Allows us to set the className on the tile
 * @return {React.Component}
 * @exported true
 * @description The AmountTile is the tile with the amount that shows on the SelectCashAmountPage
 * @example
 * <AmountTile text="Amount" className="selected-tile" />
 */


function AmountTile(props) {
  const text = props.text ?? "";
  const className = props.className ?? "";
const onClick = evt => {
  props.onClick(text);
}
  return(
    <div className={className + " amount-tile set-width text-center clickable"} onClick={onClick}>
      <b className="amount-tile-text">{text}</b>
    </div>
  );
}